import { connect, mapProps, useForm } from "@formily/react";
import { LicensePlate } from "../LicensePlate";
import { CheckOutlined } from "@ant-design/icons";

interface MerkzekerProps {
  // Form-related props
  value?: any;
  onChange?: (merkzeker: any) => void;
  errors?: Array<{ messages: string[] }>;

  // Component behavior props
  logo?: string;
}

export const Merkzeker = (props: MerkzekerProps) => {
  const features = [
    {
      icon: { style: "far", name: "check" },
      title: "Landelijk netwerk",
      description: "48 gecertificeerde vestigingen, dealer owned",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Merk equipment",
      description: "Merk specifiek gereedschap en equipment",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Merkbeleving",
      description: "Merk eigen vervangend vervoer.",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Schadeherstel via eigen dealer",
      description: "Behoud van restwaarden en fabrieksgarantie",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Getrainde medewerkers",
      description: "Merk specialistisch getrainde medewerkers",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Bovag merkgarantie bewijs",
      description: "Audit door importeur",
    },
    {
      icon: { style: "far", name: "check" },
      title: "Reparatie conform fabrikant",
      description: "Reparatie conform voorschriften fabrikant",
    },
  ];

  const form = useForm();

  // Get values from form
  const licensePlate = form.values.licensePlate;
  const brand = form.values.brand;
  const model = form.values.model;

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 mb-8">
        <div className="text-center">
          <h2 className="text-4xl font-black mb-6">Goed nieuws!</h2>
          <p className="mt-3 font-medium mx-auto max-w-[200px]">
            Schadeherstel in vertrouwde handen!
          </p>

          <div className="flex justify-center mt-6">
            <LicensePlate country="NL" size="large" isLoading={false}>
              {licensePlate}
            </LicensePlate>
          </div>
          <div className="flex justify-center">
            <span className="text-gray-400 text-xs my-4 mb-8">
              {brand} {model}
            </span>
          </div>

          <div className="flex flex-col items-center justify-center max-h-[220px] mb-2">
            <img
              src={
                props.logo ||
                "https://cdn.rumbledirect.com/static/assets/merkzeker/merkzeker-white-bg.png"
              }
              alt="Merkzeker Logo"
            />
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold mb-6 leading-7 my-1 max-w-[280px]">
            Bij MerkZeker ben je zeker van:
          </h2>

          {Array.isArray(features) && features.length > 0 ? (
            <ul className="grid grid-cols-1 gap-3">
              {features.map((feature, index) => {
                if (
                  !feature ||
                  typeof feature !== "object" ||
                  !feature.title ||
                  !feature.description ||
                  !feature.icon
                ) {
                  console.warn(`Feature at index ${index} is invalid`, feature);
                  return null;
                }

                return (
                  <li key={index} className="flex items-center space-x-4">
                    <span className="w-7 h-7 rounded-full border-2 border-black flex items-center justify-center shrink-0">
                      <CheckOutlined />
                    </span>

                    <div>
                      <h3 className="font-bold text-gray-900">
                        {feature.title}
                      </h3>
                      <p className="text-xs text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export const RumbleMerkzeker = connect(
  Merkzeker,
  mapProps((props: any, field: any) => {
    return {
      ...props,
      value: props.value,
      onChange: props.onChange,
      invalid: field?.valid === false,
      errors: field?.errors,
    };
  }),
);

export default RumbleMerkzeker;
